var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackagedIconTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13ECB240-3949-4110-A478-F99BDA6C5F37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-favourites-products",
    transform: "translate(-121, -382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(97, 358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "packaged-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,25.9 L14.6666667,16.7666667 L6.66666667,12.1333333 L6.66666667,21.2666667 L14.6666667,25.9 Z M17.3333333,25.9 L25.3333333,21.2666667 L25.3333333,12.1333333 L17.3333333,16.7666667 L17.3333333,25.9 Z M16,14.4666667 L23.9,9.9 L16,5.33333333 L8.1,9.9 L16,14.4666667 Z M5.33333333,23.6 C4.91110667,23.3556 4.58333333,23.0333333 4.35,22.6333333 C4.11666667,22.2333333 4,21.7889333 4,21.3 L4,10.7 C4,10.2111067 4.11666667,9.76666667 4.35,9.36666667 C4.58333333,8.96666667 4.91110667,8.64444 5.33333333,8.4 L14.6666667,3.03333333 C15.0889333,2.78889333 15.5333333,2.66666667 16,2.66666667 C16.4666667,2.66666667 16.9110667,2.78889333 17.3333333,3.03333333 L26.6666667,8.4 C27.0889333,8.64444 27.4166667,8.96666667 27.65,9.36666667 C27.8833333,9.76666667 28,10.2111067 28,10.7 L28,21.3 C28,21.7889333 27.8833333,22.2333333 27.65,22.6333333 C27.4166667,23.0333333 27.0889333,23.3556 26.6666667,23.6 L17.3333333,28.9666667 C16.9110667,29.2110667 16.4666667,29.3333333 16,29.3333333 C15.5333333,29.3333333 15.0889333,29.2110667 14.6666667,28.9666667 L5.33333333,23.6 Z",
    id: "Shape",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagedIconTeal);
export default __webpack_public_path__ + "static/media/packaged-icon-teal.fe162a36caf99fb362c93bee8bd95c32.svg";
export { ForwardRef as ReactComponent };